import React, { useEffect, useState } from "react";

const sections = [
    { id: "overview", label: "Overview" },
    { id: "features", label: "Features" },
    //{ id: "analytics", label: "Analytics" },
    { id: "alternatives", label: "Alternatives" },
];

export const ToolNav = () => {
    const [activeSection, setActiveSection] = useState("overview");

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                rootMargin: "-20% 0px -80% 0px",
            }
        );

        sections.forEach((section) => {
            const element = document.getElementById(section.id);
            if (element) {
                observer.observe(element);
            }
        });

        return () => observer.disconnect();
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const navHeight = 64; // Height of the ToolNav (16px top + 48px content)
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition =
                elementPosition + window.pageYOffset - navHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <nav className="fixed top-16 left-0 right-0 z-[1] bg-blue-50 dark:bg-gray-900">
            <div className="absolute inset-0 bg-grid-pattern opacity-5" />
            <div className="relative">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-4 py-4">
                        {sections.map((section) => (
                            <button
                                key={section.id}
                                onClick={() => scrollToSection(section.id)}
                                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                                    activeSection === section.id
                                        ? "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300"
                                        : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                                }`}
                            >
                                {section.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
    );
};
